import type { PaymentRailsTranslations } from "../interfaces/paymentRails";

export const paymentRailsTranslations: PaymentRailsTranslations = {
  // Page
  page_title: "Payment rails",
  page_subtitle: "Switch each rail on or off, globally or per organization, with no deploys",
  refresh_button: "Refresh",
  refresh_aria: "Refresh rail availability",
  why_banner:
    "Disabling a rail only blocks new operations: in-flight payins and payouts keep settling normally.",

  // Scope selector
  scope_label: "Scope",
  scope_placeholder: "Search by name, email or ID…",
  scope_loading: "Loading organizations…",
  scope_empty: "No organizations found.",
  scope_searching: "Searching organizations…",
  scope_search_error: "We could not complete the search; showing the organizations already loaded.",
  scope_global_option: "Global (every organization)",
  scope_global_label: "Global",
  scope_global_hint: "Global scope: the switch every organization without its own override inherits.",
  scope_org_hint: "Changes here create an override for this organization, which beats the global switch.",
  scope_catalog_error: "We could not load the organization catalog; overrides may show IDs instead of names.",
  scope_catalog_truncated:
    "There are more organizations than listed; type to search all of them. Some overrides may show the ID.",

  // KPI strip
  kpi_all: "Rail × direction",
  kpi_disabled: "Disabled",
  kpi_overrides: "With overrides",
  kpi_own_overrides: "With own override",

  // Table / cards
  section_payins: "Collections (payins)",
  section_payouts: "Payouts",
  th_rail: "Rail",
  th_country: "Country",
  th_status: "Status",
  th_source: "Source",
  th_overrides: "Overrides",
  direction_payin: "Collections",
  direction_payout: "Payouts",
  country_ar: "Argentina",
  country_br: "Brazil",
  country_co: "Colombia",
  country_mx: "Mexico",
  status_enabled: "Active",
  status_disabled: "Disabled",
  source_default: "Enabled by default",
  source_global_setting: "Global setting",
  source_global: "Inherits the global",
  source_org_override: "Organization override",
  overrides_count: "{{count}} overrides",
  overrides_count_one: "1 override",
  overrides_count_other: "{{count}} overrides",
  overrides_popover_hint: "Click an organization to open its view and manage its override.",
  action_clear_override: "Remove override",
  empty_title: "No rails to show",
  empty_description: "No rail matches the selected filter.",

  // Disable dialog (enabling flips directly from the switch)
  toggle_title_disable: "Disable {{rail}}",
  toggle_scope_global: "This change applies to every organization.",
  toggle_scope_org: "This change creates an override for the selected organization only.",
  toggle_consequence_disable:
    "New operations on this rail will be refused from now on. Anything already in flight is untouched and settles normally.",
  toggle_surviving_overrides_title: "Overrides that keep operating",
  toggle_surviving_overrides_text:
    "These organizations hold an enabled override that beats the global disable:",
  reason_label: "Reason",
  reason_placeholder: "E.g.: rail incident — network unavailable",
  reason_required: "State the reason for disabling.",
  reason_internal_hint:
    "The reason is internal: only the Coloca team sees it. Clients get a generic unavailability message.",
  toggle_cancel: "Cancel",
  toggle_confirm_disable: "Disable rail",

  // Clear override dialog
  clear_title: "Remove the override",
  clear_description:
    "The organization goes back to following the global switch (or the default state) of this rail.",
  clear_both_directions:
    "This override covers both directions: removing it affects collections and payouts at once.",
  clear_confirm: "Remove override",
  clear_cancel: "Cancel",

  // Toasts / errors
  toast_enabled: "{{rail}} enabled.",
  toast_disabled: "{{rail}} disabled. New operations will be refused.",
  toast_override_cleared: "{{rail}} override removed.",
  error_load: "We could not load the rail availability.",
  error_load_detail: "Check your connection and try again.",
  error_retry: "Retry",
  error_save: "We could not save the change.",
  error_no_write_permission: "Your user has no write permission over payments.",
};
